module.exports = __webpack_public_path__ + "static/img/jd3.167223a4.png";